import React, { useEffect, useState } from "react";
import "./FilterOptions.css";
import Icons from "../../../../Config/Images";
import { useDispatch } from "react-redux";
import { getGlobalFilterAPI } from "../../../../Store/Action/globalFilterAction";
import { applyFilters } from "../../../../Store/Slice/filterSlice";

const FilterOptions = ({ prodCatId }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState("Featured");
  const [filter, setFilter] = useState({
    featured: true,
    a_z: false,
    z_a: false,
    best_selling: false,
    new_collection: false,
    product_subcategory_id: [],
  });
  const [filtersReady, setFiltersReady] = useState(false); // New state to control API call
  const options = ["A-Z", "Z-A", "Best selling", "New collection"];

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (prodCatId) {
      setFilter((prevFilter) => ({
        ...prevFilter,
        product_subcategory_id: prodCatId.split(","),
      }));
    }
  }, [prodCatId]);
  // const handleRadioChange = (option) => {
  //   setSelectedOption(option);
  //   setIsOpen(false); // Close the dropdown after selection (optional)
  // };

  const handleRadioChange = (option) => {
    // Update the selected option and reset the filter state
    const newFilter = {
      featured: false,
      a_z: false,
      z_a: false,
      best_selling: false,
      new_collection: false,
    };

    switch (option) {
      case "A-Z":
        newFilter.a_z = true;
        break;
      case "Z-A":
        newFilter.z_a = true;
        break;
      case "Best selling":
        newFilter.best_selling = true;
        break;
      case "New collection":
        newFilter.new_collection = true;
        break;
      default:
        newFilter.featured = true;
    }
    setFiltersReady(true);
    setFilter(newFilter);
    setSelectedOption(option);
    setIsOpen(false); // Close the dropdown
  };

  // call the global filter API
  useEffect(() => {
    if (filtersReady) {
      dispatch(
        getGlobalFilterAPI(
          {},
          (result) => {
            dispatch(applyFilters(result));
          },
          filter
        )
      );
    }
  }, [dispatch, filter]);

  return (
    <div className="custom-dropdown-filter">
      <p className="sort-by-para">Sort by :</p>
      <div className="dropdown-header" onClick={toggleDropdown}>
        {selectedOption}
        <img
          style={{ height: "7px", width: "14px" }}
          src={isOpen ? Icons.vectorUpIcon : Icons.vectorDownIcon}
          alt={isOpen ? "Up arrow" : "Down arrow"}
          className="arrow-icon"
        />
      </div>
      {isOpen && (
        <div className="dropdown-menu">
          {options.map((option, index) => (
            <label key={index} className="dropdown-item">
              <input
                type="radio"
                name="filter-option"
                value={option}
                checked={selectedOption === option}
                onChange={() => handleRadioChange(option)}
              />
              <span>{option}</span>
            </label>
          ))}
        </div>
      )}
    </div>
  );
};

export default FilterOptions;
